import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { rem } from 'polished';
import { OptionsSelectTemplate } from './OptionsSelectTemplate';

export const OptionsSelectStyled = styled(OptionsSelectTemplate)`
    padding: ${rem(40)} 0 ${rem(25)} 0;
    position: relative;

    .option-list {
        position: relative;
    }

    .Collapsible__contentInner {
        display: block;
        text-align: justify;

        .Collapsible__trigger {
            background: ${({ theme }) => theme.colors.white};
        }
    }

    .Collapsible__trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${rem(8)} 0rem ${rem(8)};
        max-width: 100%;
        button {
            color: ${({ theme }) => theme.colors.default};
            font-family: ${({ theme }) => theme.fonts.fontBase};
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            line-height: 1.4;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            user-select: none;
            text-transform: uppercase;
            cursor: pointer;
            background: none;
            border: none;
        }
        position: relative;

        &.is-open {
            .selectWrapper {
                display: flex;
            }
        }
    }

    .Collapsible__trigger:after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='6' viewBox='0 0 26 14' fill='none'%3E %3Cpath d='M1 13L13 1L25 13' stroke='%23000000' stroke-width='2' stroke-linejoin='bevel'/%3E %3C/svg%3E");
        background-repeat: no-repeat;
        position: absolute;
        top: 65%;
        right: ${rem(10)};
        height: ${rem(6)};
        width: ${rem(11)};
        display: block;
        transform: rotate(180deg);
        margin-top: ${rem(-7)};

        @media (min-width: ${breakpoints.xs}px) {
            right: ${rem(5)};
        }
    }

    .Collapsible__trigger.is-open:after {
        transform: rotate(0);
    }

    .optionsTriggerWrapper {
        display: flex;
        width: calc(100% - ${rem(33)});
        & > span {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }
    }

    .selectedOptions {
        background: ${({ theme }) => theme.colors.primary};
        display: inline-block;
        width: ${rem(16)};
        height: ${rem(16)};
        text-align: center;
        font-weight: normal;
        padding-top: ${rem(1)};
        border-radius: ${rem(8)};
        color: ${({ theme }) => theme.colors.white};
    }
`;
